import styled, { css, keyframes } from 'styled-components';

const BackgroundGradient = css`
  background: linear-gradient(
    90deg,
    #e7eef0 0%,
    #f3f7f8 23.66%,
    rgba(250, 251, 252, 0.489237) 45.78%,
    #f2f6f7 78.19%,
    #e7eef0 98.76%
  );
`;

const animationDuration = '4s';

const ShineLines = keyframes`
  0% { background-position: -200px };
  100% { background-position: 340px};
`;

export const animationLine = css`
  animation: ${ShineLines} ${animationDuration} infinite linear;
`;

const LineContent = styled.div`
  ${BackgroundGradient};
  height: ${({ height }) => height || '16px'};
  width: ${({ width }) => width};
  margin-top: ${({ marginTop }) => marginTop};
  margin-bottom: ${({ marginBottom }) => marginBottom};
  border-radius: 8px;
  ${animationLine};
`;

const LineContainer = styled.div`
  display: flex;
  width: ${({ width }) => width || '100%'};
  justify-content: space-between;
  margin-bottom: ${({ marginBottom }) => marginBottom};
`;

export { BackgroundGradient, LineContent, LineContainer };
